import { __exports as lib } from '../../../../_virtual/index2.js';
import { u as uuid_1 } from '../node_modules/uuid/index.js';

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2019, Optimizely
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var uuid_1$1 = uuid_1;
	function generateUUID() {
	    return uuid_1$1.v4();
	}
	exports.generateUUID = generateUUID;
	function getTimestamp() {
	    return new Date().getTime();
	}
	exports.getTimestamp = getTimestamp;
	/**
	 * Validates a value is a valid TypeScript enum
	 *
	 * @export
	 * @param {object} enumToCheck
	 * @param {*} value
	 * @returns {boolean}
	 */
	function isValidEnum(enumToCheck, value) {
	    var found = false;
	    var keys = Object.keys(enumToCheck);
	    for (var index = 0; index < keys.length; index++) {
	        if (value === enumToCheck[keys[index]]) {
	            found = true;
	            break;
	        }
	    }
	    return found;
	}
	exports.isValidEnum = isValidEnum;
	function groupBy(arr, grouperFn) {
	    var grouper = {};
	    arr.forEach(function (item) {
	        var key = grouperFn(item);
	        grouper[key] = grouper[key] || [];
	        grouper[key].push(item);
	    });
	    return objectValues(grouper);
	}
	exports.groupBy = groupBy;
	function objectValues(obj) {
	    return Object.keys(obj).map(function (key) { return obj[key]; });
	}
	exports.objectValues = objectValues;
	function objectEntries(obj) {
	    return Object.keys(obj).map(function (key) { return [key, obj[key]]; });
	}
	exports.objectEntries = objectEntries;
	function find(arr, cond) {
	    var found;
	    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
	        var item = arr_1[_i];
	        if (cond(item)) {
	            found = item;
	            break;
	        }
	    }
	    return found;
	}
	exports.find = find;
	function keyBy(arr, keyByFn) {
	    var map = {};
	    arr.forEach(function (item) {
	        var key = keyByFn(item);
	        map[key] = item;
	    });
	    return map;
	}
	exports.keyBy = keyBy;
	function sprintf(format) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var i = 0;
	    return format.replace(/%s/g, function () {
	        var arg = args[i++];
	        var type = typeof arg;
	        if (type === 'function') {
	            return arg();
	        }
	        else if (type === 'string') {
	            return arg;
	        }
	        else {
	            return String(arg);
	        }
	    });
	}
	exports.sprintf = sprintf;
	(function (NOTIFICATION_TYPES) {
	    NOTIFICATION_TYPES["ACTIVATE"] = "ACTIVATE:experiment, user_id,attributes, variation, event";
	    NOTIFICATION_TYPES["DECISION"] = "DECISION:type, userId, attributes, decisionInfo";
	    NOTIFICATION_TYPES["LOG_EVENT"] = "LOG_EVENT:logEvent";
	    NOTIFICATION_TYPES["OPTIMIZELY_CONFIG_UPDATE"] = "OPTIMIZELY_CONFIG_UPDATE";
	    NOTIFICATION_TYPES["TRACK"] = "TRACK:event_key, user_id, attributes, event_tags, event";
	})(exports.NOTIFICATION_TYPES || (exports.NOTIFICATION_TYPES = {})); 
} (lib));
//# sourceMappingURL=index.js.map
